import React from 'react';
import classNames from 'classnames';

import { TEXTS } from 'application/pages/AdsPage/renderer/texts';

import Switcher, { LabelPlacement } from '@zvuk-b2b/react-uikit/ui/Switcher';
import DateInput, { DEFAULT_MIN_DATE } from '@zvuk-b2b/react-uikit/ui/DateInput';
import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';

import styles from './index.module.scss';

export type BroadcastDatesProps = {
  isInfinitely: boolean;
  startDate: Date | null;
  endDate: Date | null;
  setStartDate: (value: Date | null) => void;
  setEndDate: (value: Date | null) => void;
  handleChangeIsInfinitely: (value: boolean) => void;
  isInline?: boolean;
  startElementId?: string;
  endElementId?: string;
};

const BroadcastDates = ({
  isInfinitely,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  handleChangeIsInfinitely,
  isInline = false,
  startElementId = 'input_start-company',
  endElementId = 'input_end-company',
}: BroadcastDatesProps) => {
  const handleStartDateChange = (value: Date | null) => {
    if (value && endDate && DateUtils.getStartOfDay(value).getTime() > DateUtils.getStartOfDay(endDate).getTime()) {
      setEndDate(value);
    }

    setStartDate(value);
  };

  const handleEndDateChange = (value: Date | null) => {
    if (value && startDate && DateUtils.getStartOfDay(value).getTime() < DateUtils.getStartOfDay(startDate).getTime()) {
      setStartDate(value);
    }

    setEndDate(value);
  };

  return (
    <div>
      <h4 className={styles.BroadcastDatesSubtitle}>{TEXTS.FORM_BLOCK_DATE_TITLE}</h4>

      {isInline ? (
        <div className={classNames(styles.BroadcastDatesGrid, { [styles.BroadcastDatesGridSingle]: isInfinitely })}>
          <div>
            <span className={styles.label}>{TEXTS.START_DATE}</span>
            <DateInput
              elementId={startElementId}
              containerClassName={styles.BroadcastDatesInput}
              value={startDate}
              onChange={handleStartDateChange}
              popperPlacement="bottom"
            />
          </div>

          {!isInfinitely && (
            <div>
              <span className={styles.label}>{TEXTS.END_DATE}</span>
              <DateInput
                elementId={endElementId}
                containerClassName={styles.BroadcastDatesInput}
                minDate={DEFAULT_MIN_DATE.getTime() < (startDate?.getTime() || 0) ? startDate : DEFAULT_MIN_DATE}
                value={endDate}
                onChange={handleEndDateChange}
                popperPlacement="bottom"
              />
            </div>
          )}
        </div>
      ) : (
        <>
          <span className={styles.label}>{TEXTS.START_DATE}</span>

          <DateInput
            elementId={startElementId}
            containerClassName={styles.BroadcastDatesInput}
            label={TEXTS.INPUT_START_DATE_TITLE}
            value={startDate}
            onChange={handleStartDateChange}
            popperPlacement="bottom"
          />
        </>
      )}

      <Switcher
        elementId="switch_infinitely"
        className={styles.BroadcastDatesSwitcher}
        labelClassName={styles.BroadcastDatesSwitcherLabel}
        labelPlacement={LabelPlacement.RIGHT}
        isChecked={isInfinitely}
        onChange={handleChangeIsInfinitely}>
        {TEXTS.SWITCHER_INFINITELY_TITLE}
      </Switcher>

      {!isInline && !isInfinitely && (
        <>
          <span className={styles.label}>{TEXTS.END_DATE}</span>
          <DateInput
            elementId={endElementId}
            label={TEXTS.INPUT_END_DATE_TITLE}
            containerClassName={styles.BroadcastDatesInput}
            minDate={DEFAULT_MIN_DATE.getTime() < (startDate?.getTime() || 0) ? startDate : DEFAULT_MIN_DATE}
            value={endDate}
            onChange={handleEndDateChange}
            popperPlacement="bottom"
          />
        </>
      )}
    </div>
  );
};

export default BroadcastDates;
